import { Control } from "../../business-objects/control/control.model";
import { ToggleControlConfig } from "./toggle-control-config.model";

export class ToggleControl extends Control {
    config: ToggleControlConfig;
}

export interface IToggleFieldValue {
    checked: boolean;
    comment: string;
}



// WEBPACK FOOTER //
// ./src/vas/controls/toggle/toggle-control.model.ts